var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionNeedItNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8612 39.665C62.8612 52.6409 52.3421 63.16 39.3661 63.16C26.3902 63.16 15.8711 52.6409 15.8711 39.665C15.8711 26.689 26.3902 16.1699 39.3661 16.1699C52.3421 16.1699 62.8612 26.689 62.8612 39.665Z",
    fill: "url(#paint0_radial_3003_69612)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8711 50.7148C44.8711 49.6103 42.4087 48.7148 39.3711 48.7148C36.3335 48.7148 33.8711 49.6103 33.8711 50.7148",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8713 31.9431C23.4041 32.6972 25.1758 32.362 26.8286 31.1943C28.4814 30.0266 29.3894 28.4687 28.8566 27.7146",
    stroke: "black",
    strokeWidth: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3003_69612)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.9985,
    cy: 38.4458,
    r: 6.27001,
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6615 34.7292C34.0623 35.923 32.8146 38.6212 30.4271 39.4227C28.0396 40.2242 25.4165 38.8256 25.0157 37.6319C24.615 36.4381 25.5881 34.2223 28.2899 33.3152C30.9917 32.4082 33.2607 33.5355 33.6615 34.7292Z",
    fill: "#FBF2C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4295 40.5406C32.5881 41.0216 32.1318 41.6045 31.4102 41.8424C30.6887 42.0803 29.9751 41.8833 29.8165 41.4022C29.6579 40.9212 30.1142 40.3384 30.8358 40.1004C31.5573 39.8625 32.2709 40.0596 32.4295 40.5406Z",
    fill: "#FBF2C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3699 31.9431C54.8371 32.6972 53.0654 32.362 51.4126 31.1943C49.7598 30.0266 48.8518 28.4687 49.3846 27.7146",
    stroke: "black",
    strokeWidth: 0.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3003_69612)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.2143,
    cy: 38.4438,
    r: 6.27001,
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8754 34.7273C52.2761 35.921 51.0284 38.6192 48.641 39.4208C46.2535 40.2223 43.6304 38.8236 43.2296 37.6299C42.8288 36.4362 43.8019 34.2204 46.5037 33.3133C49.2055 32.4062 51.4746 33.5335 51.8754 34.7273Z",
    fill: "#FBF2C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6453 40.5406C50.8039 41.0216 50.3476 41.6045 49.626 41.8424C48.9045 42.0803 48.191 41.8833 48.0323 41.4022C47.8737 40.9212 48.3301 40.3384 49.0516 40.1004C49.7732 39.8625 50.4867 40.0596 50.6453 40.5406Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3003_69612",
    x: 21.7285,
    y: 30.1758,
    width: 16.54,
    height: 16.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3003_69612"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3003_69612",
    x: 39.9443,
    y: 30.1738,
    width: 16.54,
    height: 16.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3003_69612"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3003_69612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3661 39.665) rotate(90) scale(23.4951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionNeedItNow);
export default __webpack_public_path__ + "static/media/reaction_need-it-now.6ed15af1068911b79bfc45d3810a3250.svg";
export { ForwardRef as ReactComponent };